import { render, staticRenderFns } from "./PriorityLabelV2.vue?vue&type=template&id=6f92dcd5&scoped=true&"
import script from "./PriorityLabelV2.vue?vue&type=script&lang=js&"
export * from "./PriorityLabelV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f92dcd5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
